import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dce08934&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=dce08934&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=dce08934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_css-loader@7.1.3_@rspack+core@1.6.4_webpack_d01c569c1e49243fe86a8a8a8c1d4fe3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce08934",
  null
  
)

export default component.exports